export default __webpack_public_path__ + "3aa97bd2bc9535487a04ae7c3117dd9f.jpg";